import {Component} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSquarePlus, faXmarkSquare} from '@fortawesome/free-solid-svg-icons';
import {Router} from '@angular/router';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {validateAllFormFields} from '../../common/utils';

@Component({
    selector: 'app-add-vehicle',
    templateUrl: './add-vehicle.component.html',
    styleUrls: ['./add-vehicle.component.css'],
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule]
})
export class AddVehicleComponent {
  addVehicleForm: FormGroup;
  errorMessage: []  = [];
  vehicleChoice: any  = [
                    '',
                    'CAR',
                    'VAN',
                    'BIKE',
                    'BUS',
                    'AUTO'
                  ];
  
  contryCode: any  = [
                     "+91",
                     "+1",
                     "+44",
                     "+123" 
                      ];
                  
  constructor(private apiService: ApiService, private router: Router, private toastr:ToastrService, fb: FormBuilder, library: FaIconLibrary) {
    library.addIcons(faXmarkSquare, faSquarePlus)
    

    this.addVehicleForm = fb.group({
      empId: ['', [
                    Validators.required, 
                    Validators.minLength(3),
                    Validators.maxLength(10),
                  ]],
      vehicleNo: ['', Validators.required],
        vehicleType: ['CAR', Validators.required],
      // countryCode: ['+91', Validators.required],
      mobileNo: ['', [
                      Validators.required, 
                      Validators.pattern('^[0-9]{10}$')
                    ]
                ],
      personName: ['', Validators.required],
      comments: ['']

    });
  }
  // validateNumericInput(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   input.value = input.value.replace(/[^0-9]/g, '');
  //   this.addVehicleForm.get('mobileNo')?.setValue(input.value);
  // }

  onSubmit() {
    if (this.addVehicleForm.valid) {
      let formdata = new FormData();
      formdata.append('employee_id', this.addVehicleForm.value.empId);
      formdata.append('vehicle_number', this.addVehicleForm.value.vehicleNo);
      formdata.append('vehicle_type', this.addVehicleForm.value.vehicleType.toLowerCase());
      formdata.append('person_name', this.addVehicleForm.value.personName);
      formdata.append('mobile_number',  this.addVehicleForm.value.mobileNo);
      formdata.append('comments', this.addVehicleForm.value.comments);
      formdata.append('is_active', 'true')
      this.apiService.addVehicle(formdata).subscribe({
          next: (response:any) => {
            this.toastr.success("Vehicle added successfully.", 'Success');
            this.router.navigate(['/vehicle']);
          },
          error: (err) => {
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['vehicle_number']) {
              err['error']['vehicle_number'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['mobile_number']) {
              err['error']['mobile_number'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['person_name']) {
              err['error']['person_name'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }else if (err['error']['employee_id']) {
              err['error']['employee_id'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }else if (err['error']['vehicle_type']) {
              err['error']['vehicle_type'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }  else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!", 'Error');
            }
          }
        }
      )
    } else {
      validateAllFormFields(this.addVehicleForm);
    }
  }
  // validateAllFormFields(formGroup: FormGroup) {   
  //   Object.keys(formGroup.controls).forEach(field => {  
  //     const control = formGroup.get(field);             
  //     if (control instanceof FormGroup) {        
  //       this.validateAllFormFields(control);            
  //     } else {                                      
  //       control?.markAsTouched({ onlySelf: true });
  //     }
  //   });
  // }

  onCancel() {
    // Handle cancel action

    this.router.navigate(['/vehicle']);
  }
}
